import { styled } from '@nykaa/ui-components';

export const ViewSimilarButton = styled.div`
  height: 32px;
  width: 32px;
`;
